var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50017 16.5003C6.29105 16.5003 4.29101 15.605 2.84333 14.1574C1.39531 12.7093 0.5 10.7093 0.5 8.50017C0.5 6.2914 1.39497 4.29204 2.84195 2.84437C4.28963 1.396 6.29036 0.5 8.49983 0.5C12.9181 0.5 16.5 4.08158 16.5 8.50017C16.5 12.9188 12.9184 16.5003 8.50017 16.5003Z",
    stroke: "#20435D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70554 9.99933C5.65826 9.99933 6.4306 9.22699 6.4306 8.27426C6.4306 7.32153 5.65826 6.54919 4.70554 6.54919C3.75281 6.54919 2.98047 7.32153 2.98047 8.27426C2.98047 9.22699 3.75281 9.99933 4.70554 9.99933Z",
    stroke: "#20435D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 4.82407C7.8125 3.87148 8.58499 3.099 9.53757 3.099C10.4901 3.099 11.2626 3.87148 11.2626 4.82407C11.2626 5.77665 10.4901 6.54913 9.53757 6.54913C9.00176 6.54913 8.52288 6.30486 8.20651 5.92121C7.96017 5.62312 7.8125 5.24084 7.8125 4.82407Z",
    stroke: "#20435D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53757 13.4493C10.4903 13.4493 11.2626 12.6769 11.2626 11.7242C11.2626 10.7715 10.4903 9.99915 9.53757 9.99915C8.58484 9.99915 7.8125 10.7715 7.8125 11.7242C7.8125 12.6769 8.58484 13.4493 9.53757 13.4493Z",
    stroke: "#20435D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07812 7.23356L8.09542 5.7738",
    stroke: "#20435D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09328 10.6838L6.37891 9.52698",
    stroke: "#20435D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.24c111cda238855161a48a3ea2a2c9ad.svg";
export { ForwardRef as ReactComponent };